export default __webpack_public_path__ + "static/media/3.1e04487f.png";